/* eslint-disable */
import React, { useCallback, useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import qs from 'qs'
import { Tabs, Button, Modal, Avatar, Table, Tag, Breadcrumb, Divider } from 'antd'
import * as actions from '@/models/managers/actions'
import * as selectors from '@/models/managers/selectors'
import styles from './managers.module.scss'
import ManagerDialog from '@/components/dialogs/ManagerDialog'
import InvitationsDialog from '@/components/dialogs/InvitationsDialog'
import MGroups from '@/containers/mgroups'
import ProductCategory from '@/containers/productCategory'

function getColumns({ fetch }) {
  const dispatch = useDispatch()

  const showManagerExtDialog = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.showManagerExtDialog({
      manager: item,
      title: '设置客服分机号',
      successCallback: fetch
    }))
  })
  const showInfoModifyDialog = useCallback(({ title, row }) => () => {
    dispatch(actions.showInfoDialog({
      title,
      modify: "modify",
      row,
      submitCallback: () => { fetch() }
    }))
  })
  const showManagerCreator = useCallback(({ title = "修改客服", row = {} }) => {
    dispatch(
      actions.showSaveDialog({
        title: title,
        isEdit: true,
        rowItem: row,
        submitCallback: () => { fetch() }
      })
    );
  }, []);
  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
    },
    {
      title: '头像',
      width: 100,
      render: item => (
        <Avatar shape="square" size={42} src={item.user.avatar} />
      )
    },
    {
      title: '姓名',
      width: 200,
      render: item => (
        <div>
          <div>{item.user.name}</div>
          <small style={{ color: '#b2b2b2' }}>{item.realname}</small>
        </div>
      )
    },
    {
      title: '分组',
      width: 160,
      render: item => (
        <div>
          <div>{item.mgroup?.map((ele) => ele.name).toString()}</div>
        </div>
      )
    },
    {
      title: '注册手机',
      width: 160,
      render: item => (
        <div>
          <div>{item.user.mobile}</div>
        </div>
      )
    },
    {
      title: '近期活跃时间',
      width: 160,
      render: item => (
        <div>
          {item.lastActiveAt ? dayjs(item.lastActiveAt).fromNow() : '-'}
        </div>
      )
    },
    {
      title: '状态',
      width: 160,
      render: item => (
        <div style={{ color: item.isActive ? '#87d068' : '#CCC' }}>
          {item.isActive ? '正常' : '禁用'}
        </div>
      )
    },
    {
      title: '在线状态',
      width: 160,
      render: item =>
        <div style={{ color: item?.user?.is_online ? '#87d068' : '#CCC' }}>
          {item?.user?.is_online ? '在线' : '离线'}
        </div>

    },
    {
      title: '分机号',
      width: 160,
      render: item => (
        <div>
          {item.ext || '-'}
        </div>
      )
    },
    {
      title: '操作',
      fixed: 'right',
      width: 200,
      render: item => {
        const setActiveAction = () =>
          dispatch(actions.setActiveState(item._id, !item.isActive))
        return (
          <div>
            <a onClick={showManagerExtDialog(item)}>设置分机号</a>
            <Divider type="vertical" />
            <a onClick={setActiveAction}>{item.isActive ? '设为禁用' : '解除禁用'}</a>
            <br />
            <a onClick={showInfoModifyDialog({ title: "修改分组", row: item })}>修改分组</a>
            <Divider type="vertical" />
            <a onClick={() => { showManagerCreator({ title: "修改信息", row: item }) }}>修改信息</a>
          </div>
        )
      }
    }
  ]
}

function ManagerList(props) {
  const dispatch = useDispatch()

  const loading = useSelector(selectors.loadingSelector)
  const total = useSelector(selectors.totalSelector)
  const managers = useSelector(selectors.entriesSelectors)

  const [activeKey, setActiveKey] = useState(1)
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const groupRef = useRef(null);
  const categoryRef = useRef(null);

  const pagination = {
    showQuickJumper: true,
    total: total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1
  }

  const fetch = useCallback((params = {}) => {
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    dispatch(actions.fetchList(params))
  }, [])

  const showInfoDialog = useCallback(({ title }) => () => {
    dispatch(actions.showInfoDialog({
      title
    }))
  }, [])

  const showManagerCreator = useCallback(() => {
    dispatch(
      actions.showSaveDialog({
        title: '添加客服',
        isEdit: false,
        submitCallback: () => { fetch() }
      })
    );
  }, []);

  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }

    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    fetch(nextQuery)
  })

  const columns = getColumns({ fetch })

  useMount(() => {
    fetch()
  })

  const operations = (<>
    {activeKey == 1 && <Button size="small" onClick={() => { showManagerCreator() }}>添加客服</Button>}
    {activeKey == 2 && <Button size="small" onClick={() => { groupRef.current.add(); }}>添加分组</Button>}
    {activeKey == 3 && <Button size="small" onClick={() => { categoryRef.current.add(); }}>添加分类</Button>}
  </>)
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>客服管理</Breadcrumb.Item>
          {/* <Breadcrumb.Item>列表</Breadcrumb.Item> */}
        </Breadcrumb>
        {/* <Button size="small" onClick={showInfoDialog({ title: '添加客服' })}>添加客服</Button> */}
      </div>
      <div className={styles.content}>
        <Tabs type="card" tabBarExtraContent={operations} onChange={(key) => { setActiveKey(key) }}>
          <Tabs.TabPane tab="客服人员" key="1">
            <Table
              className={styles.table}
              columns={columns}
              rowKey="_id"
              dataSource={managers.toJS()}
              pagination={pagination}
              onChange={handleTableChange}
              loading={loading}
              scroll={{ x: '100%' }}
            ></Table>
          </Tabs.TabPane>
          <Tabs.TabPane tab="客服分组" key="2">
            <MGroups ref={groupRef} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="产品分类" key="3">
            <ProductCategory ref={categoryRef} />
          </Tabs.TabPane>
        </Tabs>
      </div>
      <ManagerDialog />
      <InvitationsDialog type="manager" />
    </div>
  )
}

export default ManagerList
